import React from 'react';
import { TFunction } from 'react-i18next';
import { Information, Trans, Link } from '@piwikpro/ui-components';
import { ConsentManagementTool } from '../../model';

interface ConsentManagementToolInfoProps {
  tool: ConsentManagementTool
  t: TFunction
  appId?: string
  legacyAnchor?: React.ReactElement
  helpCenterHref?: string
}

const DEFAULT_HELP_CENTER_HREF = 'https://help.piwik.pro/support/integrations/cookiebot-integration/';

export const ConsentManagementToolInfo: React.FC<ConsentManagementToolInfoProps> = ({
  tool,
  t,
  appId,
  legacyAnchor = <span />,
  helpCenterHref = DEFAULT_HELP_CENTER_HREF,
}) => {
  if (tool === 'PiwikLegacy') {
    return (
      <Information type="info">
        <Trans
          t={t}
          ns="consent-settings"
          i18nKey="consent-management-tool.legacy-info"
          components={{
            anchor: appId
              ? <Link size="small" href={`/consent/website/${appId}/forms/consent-forms`}>text</Link>
              : legacyAnchor,
          }}
        />
      </Information>
    );
  }

  if (tool === 'OtherConsentTool') {
    return (
      <Information type="info">
        <Trans
          t={t}
          ns="administration"
          i18nKey="apps.creator.otherConsentInfo"
          components={{
            integrationGuideLink: <Link size="small" target="_blank" href="https://help.piwik.pro/support/privacy/how-can-i-integrate-a-third-party-cookie-consent-tool-with-piwik-pro/">integration guide</Link>,
            helpCenterLink: <Link size="small" target="_blank" href={helpCenterHref}>help center instructions</Link>,
          }}
        />
      </Information>
    );
  }

  return null;
};
